module.exports = __webpack_public_path__ + "img/数据治理_01.b42daefd.svg";